<template>
  <transition name="flash">
    <div
      v-if="visible"
      :class="['fixed top-6 left-1/2 z-10000 flex -translate-x-1/2 items-center gap-2.5 rounded-2xl border px-5 py-3 shadow-2xl backdrop-blur-md', typeClass]"
    >
      <component :is="icon" class="h-5 w-5 shrink-0" />
      <div class="text-sm font-semibold tracking-wide">{{ text }}</div>
    </div>
  </transition>
</template>

<script>
import { CheckCircleIcon, ExclamationCircleIcon, InformationCircleIcon } from '@heroicons/vue/24/solid';

export default {
  name: 'FlashMessageGlobal',
  data() {
    return {
      visible: false,
      text: '',
      type: 'info',
      timer: null,
      flashHandler: null,
      clearHandler: null
    };
  },
  computed: {
    typeClass() {
      if (this.type === 'success') return 'bg-linear-to-r from-emerald-500 to-green-600 border-emerald-300/40 text-white';
      if (this.type === 'error') return 'bg-linear-to-r from-rose-500 to-red-600 border-rose-300/40 text-white';
      return 'bg-linear-to-r from-slate-700 to-slate-800 border-slate-500/40 text-white';
    },
    icon() {
      if (this.type === 'success') return CheckCircleIcon;
      if (this.type === 'error') return ExclamationCircleIcon;
      return InformationCircleIcon;
    }
  },
  methods: {
    show(detail) {
      this.clear();
      this.text = detail.text || '';
      this.type = detail.type || 'info';
      this.visible = true;
      this.timer = setTimeout(() => this.clear(), detail.duration || 3000);
    },
    clear() {
      this.visible = false;
      this.text = '';
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  },
  mounted() {
    this.flashHandler = (e) => this.show(e.detail);
    this.clearHandler = () => this.clear();
    window.addEventListener('flash-message', this.flashHandler);
    window.addEventListener('flash-clear', this.clearHandler);
  },
  beforeUnmount() {
    window.removeEventListener('flash-message', this.flashHandler);
    window.removeEventListener('flash-clear', this.clearHandler);
  }
};
</script>

<style scoped>
.flash-enter-active {
  transition: opacity 0.35s ease, transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.flash-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.flash-enter-from {
  opacity: 0;
  transform: translateY(-14px) scale(0.96);
}
.flash-leave-to {
  opacity: 0;
  transform: translateY(-8px) scale(0.98);
}
</style>
